
<div>
  <div id="edit-customer-dialog" class="ui small modal">
    <i class="close icon"></i>
    <div v-if="form.model.id" class="header">顧客情報編集</div>
    <div v-else class="header">顧客情報新規作成</div>
    <div class="content">
      <form class="ui form" :class="{'warning': form.hasErrors()}">
        <div class="required field">
          <label>顧客名</label>
          <input v-model="form.model.name" type="text" placeholder="顧客名">
          <validation-message :form="form" :field="'name'"></validation-message>
        </div>
        <div class="required field">
          <label>メールアドレス</label>
          <input v-model="form.model.email" type="text" placeholder="メールアドレス">
          <validation-message :form="form" :field="'email'"></validation-message>
        </div>
        <div class="fields">
          <div class="required eight wide field">
            <label>都道府県</label>
            <dropdown v-model="form.model.prefecture" @change="onPrefectureChange()" :placeholder="'都道府県'">
              <option v-for="each in consts.SHOP_PREFECTURE" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
            </dropdown>
            <validation-message :form="form" :field="'prefecture'"></validation-message>
          </div>
          <div class="required eight wide field">
            <label>エリア</label>
            <dropdown v-model="form.model.area" @change="onAreaChange" :placeholder="'エリア'">
              <option v-for="each in areaOptions" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
            </dropdown>
            <validation-message :form="form" :field="'area'"></validation-message>
          </div>
          <div class="eight wide field">
            <label>エリア詳細</label>
            <dropdown ref="areaDetail" v-model="form.model.area_detail" :placeholder="'エリア詳細'">
              <option value="">エリア詳細</option>
            </dropdown>
            <validation-message :form="form" :field="'area_detail'"></validation-message>
          </div>
        </div>
        <div class="field">
          <checkbox v-model="form.model.subscribed" ref="subscribed">購読する</checkbox>
        </div>
      </form>
    </div>
    <div class="actions">
      <div class="ui cancel button">閉じる</div>
      <div class="ui green button" :class="{'loading disabled': form.waiting}" @click="save()">保存する</div>
    </div>
  </div>
  <div class="action-menu">
    <button type="button" class="ui small positive button" @click="openDialog()">
      <i class="plus icon"></i>新規登録
    </button>
  </div>
  <form class="ui form" :class="{'loading': loadForm.waiting}">
    <table class="ui compact selectable table">
      <thead>
        <tr>
          <th>顧客名</th>
          <th>メールアドレス</th>
          <th>エリア</th>
          <th>エリア詳細</th>
          <th class="center aligned">メルマガ購読中</th>
          <th class="actions">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="customer in customers" :key="customer.id">
          <td>{{ customer.name }}</td>
          <td>{{ customer.email }}</td>
          <td>{{ customer.area_label }}</td>
          <td>{{ customer.area_detail_label }}</td>
          <td class="center aligned"><i v-if="customer.subscribed" class="green large check icon"></i></td>
          <td class="actions">
            <button type="button" class="ui inverted tiny positive basic button" @click="openDialog(customer)">編集</button>
            <button type="button" class="ui inverted tiny negative basic button" @click="remove(customer)">削除</button>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</div>
